export const reportConstants = {
  ACTIVITY_SUMMARY_REQUEST: 'ACTIVITY_SUMMARY_REQUEST',
  ACTIVITY_SUMMARY_SUCCESS: 'ACTIVITY_SUMMARY_SUCCESS',
  ACTIVITY_SUMMARY_FAILURE: 'ACTIVITY_SUMMARY_FAILURE',
  ACTIVITY_DASHBOARD_REQUEST: 'ACTIVITY_DASHBOARD_REQUEST',
  ACTIVITY_DASHBOARD_SUCCESS: 'ACTIVITY_DASHBOARD_SUCCESS',
  ACTIVITY_DASHBOARD_FAILURE: 'ACTIVITY_DASHBOARD_FAILURE',
  APP_ACTIVITY_SUMMARY_REQUEST: 'APP_ACTIVITY_SUMMARY_REQUEST',
  APP_ACTIVITY_SUMMARY_SUCCESS: 'APP_ACTIVITY_SUMMARY_SUCCESS',
  APP_ACTIVITY_SUMMARY_FAILURE: 'APP_ACTIVITY_SUMMARY_FAILURE',
  WORKJOURNEY_FETCH_REQUEST: 'WORKJOURNEY_FETCH_REQUEST',
  WORKJOURNEY_FETCH_SUCCESS: 'WORKJOURNEY_FETCH_SUCCESS',
  WORKJOURNEY_FETCH_FAILURE: 'WORKJOURNEY_FETCH_FAILURE',
  INTEGRATIONLOG_FETCH_REQUEST: 'INTEGRATIONLOG_FETCH_REQUEST',
  INTEGRATIONLOG_FETCH_SUCCESS: 'INTEGRATIONLOG_FETCH_SUCCESS',
  INTEGRATIONLOG_FETCH_FAILURE: 'INTEGRATIONLOG_FETCH_FAILURE',
  NOTIFICATION_FETCH_REQUEST: 'NOTIFICATION_FETCH_REQUEST',
  NOTIFICATION_FETCH_SUCCESS: 'NOTIFICATION_FETCH_SUCCESS',
  NOTIFICATION_FETCH_FAILURE: 'NOTIFICATION_FETCH_FAILURE',
  REPROCESS_REQUEST: 'WORKJOURNEY_REPROCESS_REQUEST',
  REPROCESS_SUCCESS: 'WORKJOURNEY_REPROCESS_SUCCESS',
  REPROCESS_FAILURE: 'WORKJOURNEY_REPROCESS_FAILURE',
  LASTCONTACT_FETCH_REQUEST: 'LASTCONTACT_FETCH_REQUEST',
  LASTCONTACT_FETCH_SUCCESS: 'LASTCONTACT_FETCH_SUCCESS',
  LASTCONTACT_FETCH_FAILURE: 'LASTCONTACT_FETCH_FAILURE',
  ACCESS_FETCH_REQUEST: 'ACCESS_FETCH_REQUEST',
  ACCESS_FETCH_SUCCESS: 'ACCESS_FETCH_SUCCESS',
  ACCESS_FETCH_FAILURE: 'ACCESS_FETCH_FAILURE',
  MAILLOG_FETCH_REQUEST: 'MAILLOG_FETCH_REQUEST',
  MAILLOG_FETCH_SUCCESS: 'MAILLOG_FETCH_SUCCESS',
  MAILLOG_FETCH_FAILURE: 'MAILLOG_FETCH_FAILURE',
  MAILLOG_ATTACHMENT_DOWNLOAD_REQUEST: 'MAILLOG_ATTACHMENT_DOWNLOAD_REQUEST',
  MAILLOG_ATTACHMENT_DOWNLOAD_SUCCESS: 'MAILLOG_ATTACHMENT_DOWNLOAD_SUCCESS',
  MAILLOG_ATTACHMENT_DOWNLOAD_FAILURE: 'MAILLOG_ATTACHMENT_DOWNLOAD_FAILURE',
  NOTIFICATION_CREATE_REQUEST: 'NOTIFICATION_CREATE_REQUEST',
  NOTIFICATION_CREATE_SUCCESS: 'NOTIFICATION_CREATE_SUCCESS',
  NOTIFICATION_CREATE_FAILURE: 'NOTIFICATION_CREATE_FAILURE',
  ACTIVITY_INTERVAL_REQUEST: 'ACTIVITY_INTERVAL_REQUEST',
  ACTIVITY_INTERVAL_SUCCESS: 'ACTIVITY_INTERVAL_SUCCESS',
  ACTIVITY_INTERVAL_FAILURE: 'ACTIVITY_INTERVAL_FAILURE',
  MIGRATE_ACTIVITY_INTERVAL_REQUEST: 'MIGRATE_ACTIVITY_INTERVAL_REQUEST',
  MIGRATE_ACTIVITY_INTERVAL_SUCCESS: 'MIGRATE_ACTIVITY_INTERVAL_SUCCESS',
  MIGRATE_ACTIVITY_INTERVAL_FAILURE: 'MIGRATE_ACTIVITY_INTERVAL_FAILURE',
  REPROCESS_JOURNEY_REQUEST: 'REPROCESS_JOURNEY_REQUEST',
  REPROCESS_JOURNEY_SUCCESS: 'REPROCESS_JOURNEY_SUCCESS',
  REPROCESS_JOURNEY_FAILURE: 'REPROCESS_JOURNEY_FAILURE',

  LICENSEUSAGE_CURRENT_REQUEST: 'LICENSEUSAGE_CURRENT_REQUEST',
  LICENSEUSAGE_CURRENT_SUCCESS: 'LICENSEUSAGE_CURRENT_SUCCESS',
  LICENSEUSAGE_CURRENT_FAILURE: 'LICENSEUSAGE_CURRENT_FAILURE',
  LICENSEUSAGE_HISTORY_REQUEST: 'LICENSEUSAGE_HISTORY_REQUEST',
  LICENSEUSAGE_HISTORY_SUCCESS: 'LICENSEUSAGE_HISTORY_SUCCESS',
  LICENSEUSAGE_HISTORY_FAILURE: 'LICENSEUSAGE_HISTORY_FAILURE',
  LICENSEUSAGE_FILE_REQUEST: 'LICENSEUSAGE_FILE_REQUEST',
  LICENSEUSAGE_FILE_SUCCESS: 'LICENSEUSAGE_FILE_SUCCESS',
  LICENSEUSAGE_FILE_FAILURE: 'LICENSEUSAGE_FILE_FAILURE',

  APPROVEDREQUESTS_FETCH_REQUEST: 'APPROVEDREQUESTS_FETCH_REQUEST',
  APPROVEDREQUESTS_FETCH_SUCCESS: 'APPROVEDREQUESTS_FETCH_SUCCESS',
  APPROVEDREQUESTS_FETCH_FAILURE: 'APPROVEDREQUESTS_FETCH_FAILURE',

  SESSIONS_FETCH_REQUEST: 'SESSIONS_FETCH_REQUEST',
  SESSIONS_FETCH_SUCCESS: 'SESSIONS_FETCH_SUCCESS',
  SESSIONS_FETCH_FAILURE: 'SESSIONS_FETCH_FAILURE',

  OUTSIDEJOURNEY_FETCH_REQUEST: 'OUTSIDEJOURNEY_FETCH_REQUEST',
  OUTSIDEJOURNEY_FETCH_SUCCESS: 'OUTSIDEJOURNEY_FETCH_SUCCESS',
  OUTSIDEJOURNEY_FETCH_FAILURE: 'OUTSIDEJOURNEY_FETCH_FAILURE',

  LASTCONTACT_PDF_REQUEST: 'LASTCONTACT_PDF_REQUEST',
  LASTCONTACT_PDF_SUCCESS: 'LASTCONTACT_PDF_SUCCESS',
  LASTCONTACT_PDF_FAILURE: 'LASTCONTACT_PDF_FAILURE',
};
